import { Container, Box, Typography } from "@mui/material"
import Project from "components/Project"
import Frame from "components/Frame"

const Projects = () => {
  return (
  <Container maxWidth={false} disableGutters>
    <Box pl={2} pr={2}>

      <Box mb={2} pr={3} textAlign={"right"}>
        <Typography fontFamily="General Sans" fontSize="1.2rem" fontWeight={800}>
          Select Work
        </Typography>
      </Box>

      <Project
        title = "Monochrome"
        subtitle = "A work in progress"
        date = "2026"
        media = {[
          <img src="/media/art/md/lp477.png" alt="" width="100%"></img>
        ]}
      />

      <Project
        title = "Envelop"
        subtitle = "Recreation of Aldo Giorgini's numerical visualization software FIELDS"
        date = "2025"
        media = {[
          <img src="/media/art/md/ixafv.png" alt="" width="100%"></img>,
          <img src="/media/art/md/skriq.png" alt="" width="100%"></img>,
          <img src="/media/art/md/doy0r.png" alt="" width="100%"></img>
        ]}
        link = "https://envelop.pxlq.art"
      />

      <Project
        title = "Syndication"
        subtitle = "Really simple art syndication (RSS)"
        date = "2025"
        media = {[
          <Frame url={"https://api.pxlq.art/project/mathfont?render"}/>
        ]}
        link = "https://github.com/latent-laboratory/rss"
      />

      <Project
        title = "Ink Blots"
        subtitle = "What do you see?"
        date = "2025"
        media = {[
          <img src="/media/art/md/ve7e7.png" alt="" width="100%"></img>
        ]}
        link = "https://blots.pxlq.art"
      />

      <Project
        title = "Motif"
        subtitle = "A 4x4 grid of infinte possibilities"
        date = "2025"
        media = {[
          <img src="/media/art/md/sgg8c.png" alt="" width="100%"></img>
        ]}
        link = "https://motif.pxlq.art"
      />

      <Project
        title = "Algorithmic botany"
        subtitle = "3D L-systems for flowers and trees"
        date = "2024"
        media = {[
          <img src="/media/art/md/ushr6.png" alt="" width="100%"></img>
        ]}
        link = "https://generator.pxlq.art/arbory"
      />

      <Project
        title = "Genuary"
        subtitle= "One program per day for 31 days"
        date = "2024"
        media = {[
          <img src="/media/art/md/45lak.png" alt="" width="100%"></img>,
          <img src="/media/art/md/g6s05.png" alt="" width="100%"></img>,
          <img src="/media/art/md/jggfn.png" alt="" width="100%"></img>
        ]}
        link = "https://genuary.art/prompts"
      />
      
      <Project
        title = "Art programming interfaces"
        subtitle = "terraform art --generate-random"
        date = "2023"
        media = {[
          <img src="/media/art/md/9retz.png" alt="" width="100%"></img>
        ]}
        link = "https://generator.pxlq.art/mathfont"
      />

      <Project
        title = "Gravity"
        subtitle = "A bug in the code"
        date = "2021"
        media = {[
          <img src="/media/art/md/4qt3e.png" alt="" width="100%"></img>
        ]}
        link = "https://foundation.app/@pxlq/foundation/75129"
      />

      <Project
        title = "Ascii ships"
        subtitle = "Community-driven generative algorithms"
        date = "2021"
        media = {[
          <img src="/media/art/md/9fmpl.png" alt="" width="100%"></img>
        ]}
        link = "https://catalog.ships.pxlq.art"
      />

      <Project
        title = "Infinethum"
        subtitle= "Limited edition series, proof of concept for Art Blocks Engine"
        date = "2021"
        media = {[
          <Frame url={"https://api.infinethum.xyz/variant/4/2"}/>
        ]}
        link = "https://infinethum.xyz"
      />

      <Project
        title = "Space debris"
        subtitle = "L5-A752 to dispatch... we have been attacked, badly"
        date = "2021"
        media = {[
          <Frame url={"https://generator.artblocks.io/79000008"}/>
        ]}
        link = "https://generator.artblocks.io/79000008"
      />

      <Project
        title = "Cyber cities"
        subtitle = "A new medium for dynamic digital art"
        date = "2021"
        media = {[
          <Frame url={"https://generator.artblocks.io/14000080"}/> 
        ]}
        link = "https://cyber.pxlq.art"
      />

      <Project
        title = "Decipher"
        subtitle = "Can you sell an art algorithm?"
        date = "2020"
        link = "https://www.raster.art/token/ethereum/0xb80fbf6cdb49c33dc6ae4ca11af8ac47b0b4c0f3/4"
        media = {[
          <img src="/media/art/md/i4kp4.png" alt="" width="100%"></img>
        ]}
      />

      <Project
        title = "Automatons"
        subtitle = "Early explorations of the ERC-721 standard for tokenized artworks"
        date = "2019"
        link = "https://automaton.pxlq.art"
        media = {[
          <img src="https://automaton.pxlq.art/ipfs/raw/T029.gif" alt="" width="100%" className="pixelated"></img>
        ]}
        border = {false}
      />

    </Box>
  </Container>
  )
}

export default Projects